import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import {EksDetailTabs} from "./EksDetailTabs";
import { useTranslation } from "react-i18next";
import { Show } from "@refinedev/antd";

const RESOURCE = 'eks';

export const EKSPage = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();

  const navigateToDetail = (record, e) => {
    e.preventDefault();
    navigate({ resource: RESOURCE, key: record.name, action: 'show' });
  };

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", hidden: true },
    { title: "EKS Name", dataIndex: "name", key: "name", render: (text, record) => <a onClick={(e) => navigateToDetail(record, e) }>{text}</a> },
    { title: "Region", dataIndex: "region", key: "region" },
    { title: "Version", dataIndex: "version", key: "version" },
    { title: "AIOps Count", dataIndex: "instances", key: "instances" }
  ];
  
  return (
    <ResourceListLayout
      title={t('eks.title.list', 'EKS')}
      resource={RESOURCE}
      columns={columns}
      children={<EksDetailTabs />}
    >
    </ResourceListLayout>
  );
};